import Vue from 'vue'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'

Vue.use(Vuex)

// Translations

const languages = new Set()

languages.add('en')
languages.add('hr')
languages.add('de')

import translationsEn from '../../lang/en.json'
import translationsHr from '../../lang/hr.json'
import translationsDe from '../../lang/de.json'

// Global state

const store = new Vuex.Store({
    state: {
        loading: {
            status: false,
            duration: 0
        },
        mainMenu: {
            status: false
        },
        langs: languages
    }
})

Vue.use(vuexI18n.plugin, store)

const i18n = Vue.i18n

i18n.add('en', translationsEn)
i18n.add('hr', translationsHr)
i18n.add('de', translationsDe)
i18n.set('en')
i18n.fallback('en')

import { routes } from './routes'

export {
    Vue,
    store,
    languages,
    i18n,
    routes
}
